import * as React from 'react';
import { Fragment } from 'react';
import Pagination from '../components/Pagination';
import {
	BulkActionProps,
	BulkDeleteButton,
	DateInput,
	List,
	ListProps,
	TextInput
} from 'react-admin';

import { Theme, useMediaQuery } from '@material-ui/core';
import { ExportField, generateExporter } from '../util/Exporter';
import { LiveTrainingMessageDatagrid } from "./LiveTrainingMessageDatagrid";
import { LiveTrainingMessage } from "./LiveTrainingMessage";
import { LiveTrainingMessageList } from "./LiveTrainingMessageList";


const TrainingsBulkActionButtons = (props: BulkActionProps) => (
	<Fragment>
		<BulkDeleteButton {...props} undoable={false}/>
	</Fragment>
);

export const exportFields: ExportField[] = [
	{ key: 'id', header: 'ID' },
	{ key: 'date', header: 'Date' },
	{ key: 'content', header: 'content' },
	{ key: 'organization.name', header: 'Organization' }
];

export const LiveTrainingsMessageData = (props: ListProps): React.ReactElement => {
	const isXSmall = useMediaQuery<Theme>(theme => theme.breakpoints.down('xs'));
	const exportDataMapper = (entity: LiveTrainingMessage) => entity;

	const trainingsFilter = [
		<TextInput source="content" alwaysOn label="SEARCH"/>,
		<DateInput source="from_date" label="FROM_CREATED_AT"
		           alwaysOn/>,
		<DateInput source="to_date" label="TO_CREATED_AT"
		           alwaysOn/>
	];

	return (
		<Fragment>
			<List
				exporter={generateExporter('הודעות אימוני לייב', exportFields, exportDataMapper)}
				{...props}
				filters={trainingsFilter}
				bulkActionButtons={<TrainingsBulkActionButtons/>}
				title="LIVE_TRAININGS_MESSAGES"
				sort={{ field: '_createdAt', order: 'DESC' }}
				perPage={20}
				pagination={<Pagination/>}
			>
				{isXSmall ? <LiveTrainingMessageList/> : <LiveTrainingMessageDatagrid/>}
			</List>
		</Fragment>
	);
};
